// ** React Imports
import { useEffect } from 'react'

// ** Next Import
import { useRouter } from 'next/router'

// ** Hooks Import
import { useAuth } from 'src/hooks/useAuth'

const GuestGuard = props => {
  const { children, fallback } = props

  const auth = useAuth()

  const router = useRouter()

  // The access token lives in memory only now, so a stale storage check can't tell
  // us whether the visitor is actually logged in - auth.isUserLoggedIn (set once the
  // boot-time silent refresh + /user call resolve) is the authoritative signal.
  useEffect(() => {
    if (!router.isReady) {
      return
    }
    if (auth.isUserLoggedIn) {
      router.replace('/')
    }
  }, [router, router.route, auth.isUserLoggedIn])

  if (auth.loading || auth.isUserLoggedIn) {
    return fallback
  }

  return <>{children}</>
}

export default GuestGuard
